const moduleName = "wms/packagingMaterialsManage/";
export const id = {
    id: "BASIC_DATA_PACKAGE_MATERIALS",
    name: "包材管理",
    type: "menu",
    apiName: "getPackageMaterialsList",
    url: `${moduleName}list`
};

export const children = {
    // GET_LIST: {
    //     id: 'BASIC_DATA_PACKAGE_MATERIALS_GET_LIST',
    //     apiName: 'getCarTypes',
    //     method: 'POST',
    //     name: '获取列表',
    //     type: 'view',
    //     url: `${moduleName}carType/getCarTypes`
    // },
    ADD_DATA: {
        id: "BASIC_DATA_PACKAGE_MATERIALS_ADD_DATA",
        apiName: "addPackageMaterials",
        method: "POST",
        name: "新建",
        type: "view",
        url: `${moduleName}save`
    },
    DEL_DATA: {
        id: "BASIC_DATA_PACKAGE_MATERIALS_CODE",
        apiName: "delPackageMaterials",
        method: "POST",
        name: "删除",
        type: "view",
        url: `${moduleName}delete`
    },
    EDIT_DATA: {
        id: "BASIC_DATA_PACKAGE_MATERIALS_EDIT_DATA",
        apiName: "editPackageMaterials",
        method: "POST",
        name: "编辑",
        type: "view",
        url: `${moduleName}save`
    }
    // LOOK_MORE: {
    //     id: 'BASIC_DATA_PACKAGE_MATERIALS_LOOK_MORE',
    //     name: '查看',
    //     type: 'view'
    // }
};
